export default function KeyMetrics({metrics}) {
  return (
    <div className="bg-white rounded-xl shadow p-5 min-h-[400px] overflow-auto">
     
      <div className="space-y-4">
        {metrics.map((metric) => (
          <div
            key={metric.id}
            className={`flex items-center justify-between rounded-lg p-4 ${metric.bg}`}
          >
            <div className="flex items-center space-x-3">
              <div
                className={`w-10 h-10 flex items-center justify-center rounded-md ${metric.iconBg}`}
              >
                <metric.icon className="w-6 h-6 text-white" />
              </div>
            <div>
                  <h6 className="text-gray-500 font-medium">{metric.title}</h6>
              <p className="text-gray-700 font-bold text-lg">
              {metric.value}
            </p>
            </div>
            </div>
            
          </div>
        ))}
      </div>
    </div>
  );
}